import actions from './actions'
import mutations from './mutations'
import getters from './getters'

let state = {
  addTranslatorDialog: false,
  translatorEditDialog: false,
  totalTranslators: 0,
  activeTranslatorsIds: []
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/translators/index.js